import React from 'react';

import information from '../../../images/information.svg';

import { FOHImage } from '../../ingredients';

export const FOHInformationIcon = (props: any) => (
  <FOHImage
    source={{ uri: information }}
    style={{
      width: 24,
      height: 24
    }}
    {...props}
  />
);
